var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlackForwardIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "arrow_forward_ios"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4273_6796",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4273_6796)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "arrow_forward_ios_2",
    d: "M5.81598 13.9629C5.55563 14.2232 5.13185 14.2215 4.8715 13.9612C4.61115 13.7009 4.60949 13.2771 4.86984 13.0167L9.88819 7.99838L4.86984 2.98004C4.60949 2.71969 4.61115 2.29592 4.8715 2.03557C5.13185 1.77522 5.55563 1.77355 5.81598 2.0339L11.3091 7.52698C11.5694 7.78733 11.5694 8.20944 11.3091 8.46979L5.81598 13.9629Z",
    fill: "#0F191A",
    stroke: "#0F191A",
    strokeWidth: 0.4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackForwardIcon);
export default __webpack_public_path__ + "static/media/BlackForwardIcon.73ab12b29060099fe2f95bcd8ecbd20f.svg";
export { ForwardRef as ReactComponent };